import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MainHeader } from '../MainHeader';
import { PhotoCollection } from '../PhotoCollection';
import { images } from './images';
import './styles.css';

export const Birthdays = () => {
  useEffect(() => {
    document.title = "Rue's Events Designs - Birthdays";
  }, []);

  return (
    <div className="collection-page">
      <MainHeader home={false} about={false} gallery={true} contact={false} />
      <section className="collection-hero">
        <p className="section-kicker">Rue's Events gallery</p>
        <h1>Birthdays</h1>
        <p>Personal celebrations designed with colour, detail and memorable moments in mind.</p>
        <div className="collection-back-link">
          <Link to="/gallery">← Back to all collections</Link>
        </div>
      </section>
      <div className="collection-gallery-shell">
        <PhotoCollection images={images} label="Birthdays" />
      </div>
    </div>
  );
};
